// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1l5jq","errors":"Errors_errors__1FzPL"};